import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { AsociacionesService, AsociadosService, CargosService, EjerciciosService, HistoricoService, TipoAsociacionesService } from "../../api";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private asociacionesService: AsociacionesService,
    private asociadosService: AsociadosService,
    private cargosService: CargosService,
    private ejerciciosService: EjerciciosService,
    private historicoService: HistoricoService,
    private tipoAociacionesService: TipoAsociacionesService
  ) {}

  canActivate(): boolean {
    if (this.authService.isLoggedIn){
      let token = this.authService.getToken();
      this.asociacionesService.configuration.accessToken = token;
      this.asociadosService.configuration.accessToken = token;
      this.cargosService.configuration.accessToken = token;
      this.ejerciciosService.configuration.accessToken = token;
      this.historicoService.configuration.accessToken = token;
      this.tipoAociacionesService.configuration.accessToken = token;
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

}
